import { gameConfigStore } from '@pascal/pascal-core';
import { catchMeGameId, gameNameDependGameIds } from './gameConstant';

export const gameName = `${gameNameDependGameIds[gameConfigStore.gameId]}`;
export const gameNameForUrl = `${gameNameDependGameIds[catchMeGameId]}`;
export const socketGamePath = 'game';
